<template>
  <div class="row">
    <page-loader
      v-if="loader"
      class="col-20"
    />
    <div
      v-else
      class="col-20 std-wrapper p-4"
    >
      <div class="row">
        <file-status-info
          :member="member"
          :is-advertiser="isAdvertiser"
        />
        <div class="col-20 col-lg-4">
          <div v-if="isAdvertiser">
            <tip-info
              :member="member"
              :is-advertiser="isAdvertiser"
              class="mb-4 mb-lg-0"
            />
          </div>
          <div v-else>
            <file-add
              v-if="showFileAdd"
              :member="member"
              class="mb-2"
            />
            <tip-info
              :member="member"
              :is-advertiser="isAdvertiser"
              class="mb-4 mb-lg-0"
            />
          </div>
        </div>
        <div class="col-20 col-lg-16">
          <div
            v-if="files.length === 0"
            class="d-flex w-100 h-100 align-items-center justify-content-center"
          >
            {{ $t('view-CampaignsFiles.empty-list') }}
          </div>
          <div class="row">
            <div
              v-for="file in files"
              :key="file.id"
              class="col-10 col-md-5"
            >
              <file-item
                :member="member"
                :file="file"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileAdd from './files-partials/Add.vue'
import fileItem from './files-partials/Item.vue'
import fileStatusInfo from './files-partials/StatusInfo.vue'
import tipInfo from './files-partials/TipInfo.vue'

export default {
  components: {
    'file-add': fileAdd,
    'file-item': fileItem,
    'file-status-info': fileStatusInfo,
    'tip-info': tipInfo
  },
  props: {
    campaign: {
      type: Object,
      default: () => { return {} }
    },
    member: {
      type: Object,
      default: () => { return {} }
    }
  },
  data: function () {
    return {
      loader: true
    }
  },
  computed: {
    isAdvertiser () {
      return this.$store.state.user.profile.type === 'advertiser'
    },
    files () {
      return this.$store.state.campaignsFiles.files[this.member.id] || []
    },
    showFileAdd () {
      const correctStatuses = ['waiting_for_draft', 'waiting_fot_draft_approval', 'waiting_fot_publication', 'waiting_for_publication_approval']
      return !this.isAdvertiser && correctStatuses.includes(this.member.status)
    }
  },
  beforeMount () {
    this.loader = true

    this.$store.dispatch('campaignsFiles/getFiles', this.member.id)
      .then(() => {
        this.loader = false
      }).catch((e) => {
        this.loader = false
      })
  }
}
</script>

<style lang="scss" scoped>
  .send-message {
    position: relative;
    textarea {
      border-color: $nh-gray;
      padding-right: 2.1rem;
    }
    .send {
      position: absolute;
      bottom: 0;
      right: 10px;
      cursor: pointer;
      padding: 0.75rem;
      background-color: $warning;
      border-radius: 5px;
    }
  }
</style>
